import { useDetectorMapEntitiesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { useCallback } from 'react';

export const useSiteNamesDataSource = (): DataSource<FormOption[]> => {
  const [getSiteNames] = useDetectorMapEntitiesLazyQuery();

  const load = useCallback(async () => {
    const { data } = await getSiteNames();
    const siteOptions = data?.detectorMapEntities.map((site) => ({
      label: site.name,
      value: site.id,
    }));

    return siteOptions as FormOption[];
  }, [getSiteNames]);

  return { load };
};
